import type { Ref } from "vue";
import { onMounted } from "vue";

import { useNativeEvents } from "@/composables/useNativeEvents";
import { distance2, isEqual } from "@/math/coordinates";
import { longClickDist } from "@/model/Settings";
import type { ViewportCoordinate } from "@/model/coordinates";
import { scrollPos } from "@/utils/dom/coordinates";
import { isLinkDrag } from "@/utils/dom/dom";
import { getPointer, mouseState } from "@/utils/dom/pointer";

import { isPinching } from "./pinch";

export function useLongClick(
  el: Ref<HTMLElement | null>,
  longClick: number,
  handler: (param: { element: HTMLElement; pos: ViewportCoordinate }) => void,
) {
  const { addEventListener } = useNativeEvents();

  onMounted(() => {
    const element = el.value!; //assume el is not null in onMounted
    addEventListener(element, "pointerdown", (e: PointerEvent) => {
      if (isLinkDrag(e)) return;

      const id = e.pointerId;
      const scrollBefore = scrollPos();
      const mouse = mouseState();

      window.setTimeout(() => {
        const pointer = getPointer(id);
        const noMove = pointer && distance2(pointer.pos, pointer.downPos) < longClickDist;
        const noScroll = isEqual(scrollPos(), scrollBefore, 1);
        const noClick = e.pointerType !== "mouse" || mouse.isButtonDownOnce();
        if (noMove && noScroll && noClick && !isPinching(id)) {
          handler({ element, pos: pointer.pos });
        }
      }, longClick);
    });
  });
}
